// data.js
export const students = [
    {
      name: 'John Doe',
      class: '5th Grade',
      birthday: '2024-07-24', // YYYY-MM-DD format
    },
    {
      name: 'John Doe',
      class: '5th Grade',
      birthday: '2024-07-24', // YYYY-MM-DD format
    },
    {
      name: 'John Doe',
      class: '5th Grade',
      birthday: '2024-07-24', // YYYY-MM-DD format
    },
    {
      name: 'John Doe',
      class: '5th Grade',
      birthday: '2024-07-24', // YYYY-MM-DD format
    },
    {
      name: 'John Doe',
      class: '5th Grade',
      birthday: '2024-07-24', // YYYY-MM-DD format
    },
    {
      name: 'Mrs. Neelam Gupta',
      class: 'Principal',
      birthday: '2024-07-25', // YYYY-MM-DD format
    },
    {
      name: 'Jane Smith',
      class: '6th Grade',
      birthday: '1/9/2024',
    },
    {
      name: 'John Doe',
      class: '11th Grade',
      birthday: '2/9/2024',
    },
    {
      name: 'Mr. Sample1',
      class: '11th Grade',
      birthday: '3/9/2024',  
    },
    {
      name: 'Mr. Sample2',
      class: '11th Grade',
      birthday: '4/9/2024',  
    },
    {
      name: 'Mr. Sample3',
      class: '11th Grade',
      birthday: '5/9/2024',  
    },
    {
      name: 'Mr. Sample4',
      class: '11th Grade',
      birthday: '6/9/2024',  
    },
    {
      name: 'John Doe',
      class: '11th Grade',
      birthday: '7/9/2024',
    },
    {
      name: 'Jane Smith',
      class: '6th Grade',
      birthday: '8/9/2024',
    },
    
    // Add more students as needed
  ];
  
